module.exports = __webpack_public_path__ + "static/img/widget-4.3cfdc6ab.png";